import { Button } from '@/components/ui/button';

interface InlineRetryErrorProps {
  message: string;
  onRetry: () => void;
  disabled?: boolean;
}

export function InlineRetryError({ message, onRetry, disabled }: InlineRetryErrorProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <p className="text-sm text-destructive">{message}</p>
      <Button size="sm" variant="outline" className="max-sm:h-11" onClick={onRetry} disabled={disabled}>
        Retry
      </Button>
    </div>
  );
}
